/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ImageGallery from 'react-image-gallery';


const ModelShow = ({ lgShow, setLgShow, images }) => {
  const { t: uiT } = useUiTranslation();

    const handleClose = () => setLgShow(false);



    return (
        <Modal
            size="md"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
             
        >
            <Modal.Header /*closeButton*/>
                <Modal.Title id="example-modal-sizes-title-lg">
                {uiT("ui.showInStore")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ImageGallery items={images.map((i)=>({original:i,thumbnail:i,originalHeight :"350px",thumbnailHeight:"75px"}))} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>
                    {uiT("annule")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModelShow;